import * as yup from "yup";

export const CountrySetupValidationSchema = yup.object({
  name: yup
    .string()
    .required("Country Name is required")
    .min(1, "Minimum length 1 characters")
    .max(60, "Maximum length 60 characters"),
    shortCode: yup
    .string()
    .required("Country Short Code is required")
    .min(1, "Minimum length 1 characters")
    .max(3, "Maximum length 3 characters"),
    countryType: yup
    .string()
    .required("Country Type is required"),
    // logo: yup
    // .string()
    // .required("Country Logo is required"),
})